<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn fab  dark large color="brown darken-4" fixed right bottom><v-icon>person_add</v-icon></v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>LINK MOVIE TO {{ campus.toUpperCase() }} CAMPUS</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
             
             </v-card-text>
             <v-card-text>
                <v-form class="px-3" ref="form"> 
                     <v-select label="Categories*"  item-text="campus" :items="cat" v-model="cats"  prepend-icon="contacts"></v-select>
                    
                     <v-select label="Movies*" item-text="campus" :items="mov" v-model="movs"  prepend-icon="contacts"></v-select>
                     <v-select label="No of Slots available*" item-text="gender" :items="slotsAva" v-model.number="slotsAvas"  prepend-icon="contacts"></v-select>
                     <v-text-field label="Price*" v-model="price" :rules="priceRules"  prepend-icon="money"></v-text-field>
                     <v-menu lazy :close-on-content-click="false" transition="scale-transition" offset-y
                       full-width :nudge-right="40" max-width="290px" min-width="290px">
        
                     <v-text-field slot="activator" label="Select viewing date" v-model="date" prepend-icon="event" readonly></v-text-field>
                     <v-date-picker v-model="date" no-title scrollable actions></v-date-picker>
                     <template slot-scope="{ save , cancel }">
                         <v-card-actions>
                             <v-spacer></v-spacer>
                             <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                             <v-btn flat color="primary" @click="save">saves</v-btn>
                         </v-card-actions>
                     </template>
                      </v-menu>
                      <v-menu lazy :close-on-content-click="false" transition="scale-transition" offset-y
                       full-width :nudge-right="40" max-width="290px" min-width="290px">
        
                     <v-text-field slot="activator" label="Select viewing time" v-model="time" prepend-icon="event" readonly></v-text-field>
                     <v-time-picker v-model="time"  format="24hr"> </v-time-picker>
                     <template slot-scope="{ save , cancel }">
                         <v-card-actions>
                             <v-spacer></v-spacer>
                             <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                             <v-btn flat color="primary" @click="save">saves</v-btn>
                         </v-card-actions>
                     </template>
                     </v-menu>
                    <span v-if="error_state" class="red--text">{{error_value}}</span>
                    <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled" >Link Movie</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {addSubModule} from '@/model';
import moment from 'moment';
import {loadCategory,loadMovie} from '@/validator'

export default {
    name: 'LinkMovie',
    props:{
        campus :{
            required:true
        }
        },
    data() {
        return {
         isDisabled:false,
         error_state:false,
         error_value:'You must supply a gender',
         test:null,
         cats:[],
         cat:loadCategory(this.$store.getters.getCategory),
         movs:[],
         mov:[],
         price:'',
         date:null,
         time:null,
         slotsAvas:[],
         slotsAva:[
             {header:'Super'},
              1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,
              ],
              
            priceRules:[
               v => v.length >=2  || "Minimum length is 2 characters",
               v => v.length <=30  || "Maximum length is 5 characters" 
           ]
        
        };
    },
    watch:{
        cats: function(val){
            this.movs = [];
            this.mov = loadMovie(val,this.$store.getters.getMovie)
        }
    },
    methods: {
        
        add() {
            let self=this;
            if(this.$refs.form.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            
            if(this.cats.length==0){
                    self.error_state = true;
                    self.error_value = "You must select a category"
                    return
            }else if(this.movs.length==0){
                    self.error_state = true;
                    self.error_value = "You must select a movie"
                    return
            }else if(this.slotsAvas.length==0){
                    self.error_state = true;
                    self.error_value = "You must select number of available slots"
                    return
            }else if(this.date==null){
                    self.error_state = true;
                    self.error_value = "You must select viewing date"
                    return
            }else{
                if(this.time == null){
                    self.error_state = true;
                    self.error_value = "You must select viewing time"
                    return
                }
            }
            let itemname = (this.movs+this.cats+this.date+this.time).toLowerCase();
            let useradd = this.$store.getters.getStaff.name;
            let newitem = {name:itemname,movName:this.movs,category:this.cats,price:this.price,slots:this.slotsAvas,vTime:this.time,vDate:this.date,dateadded:datenow,useradd:useradd};
            console.log(newitem);
            self.error_state = false;
            self.isDisabled = true;
            
           
            
              addSubModule('campus',this.campus,itemname,newitem,function(response){
                  if(response.value === true){
                      console.log("This is response: ",response);
                      alert('Movie has been linked to campus successfully');
                      self.$store.dispatch('updateLinkedMovies',self.campus);
                    self.isDisabled = false;
                  }else{
                      self.isDisabled = false;
                      if(response.err == 'name'){
                          alert('You have already added that movie to that viewing time and date');
                      }else{
                          alert('An error occured please try again later');
                      
                      }
                  }

               })
            }
        }
    }
};
</script>

<style scoped>
</style>